export const url = "https://botpower.rendit.tech/api/atlas"
export const botPowerKey = "e7fa0c96e7514a90b2cc5acf264f001d"
export const matterport_link = "https://my.matterport.com/show/?m="
